<template>
  <div class="d-flex align-center qx-checkbox">
    <div
      v-if="!invisible"
      class="input-group-sm d-flex"
      @click.stop="onChange">
      <div
        class="custom-checkbox"
        :title="label"
        :class="[{ disabled }]">
        <input
          :id="id"
          type="checkbox"
          :value="checked"
          :checked="checked">
        <div
          :id="`${id}-custom-checkbox`"
          class="custom-checkbox-input"
          :class="[{ disabled, checked, indeterminate }]">
          <em
            class="qx-icon"
            :class="{
              'icon-check-box-active': checked,
              'icon-check-box-negative': indeterminate,
            }" />
        </div>
        <slot name="label">
          <span class="custom-label">
            {{ label }}
          </span>
        </slot>
      </div>
    </div>
    <qx-info-icon
      v-if="infoIconId"
      :id="infoIconId"
      :position="infoIconPosition"
      :origin="infoIconOrigin"
      :title="infoIconTitle" />

    <em
      v-if="withCaret"
      class="qx-icon"
      :class="expanded ? 'icon-arrow-up-sm' : 'icon-arrow-down-sm'"
      @click.stop="onCaretChange" />
  </div>
</template>

<script>
import QxInfoIcon from '@/elements/infoIcon.vue';

export default {
  name: 'QxCheckbox',
  components: {
    QxInfoIcon,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    invisible: {
      type: Boolean,
      default: false,
    },
    disabledTip: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    infoIconId: {
      type: String,
      default: '',
    },
    infoIconTitle: {
      type: String,
      default: '',
    },
    infoIconPosition: {
      type: String,
      default: 'end center',
    },
    infoIconOrigin: {
      type: String,
      default: 'auto',
    },
    withCaret: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onChange', 'onCaretChange'],
  data() {
    return {
      expanded: false,
      check: false,
    };
  },
  methods: {
    onChange(event) {
      if (!this.disabled) {
        this.$emit('onChange', event.returnValue);
      }
    },
    onCaretChange() {
      this.expanded = !this.expanded;
      this.$emit('onCaretChange');
    },
  },
};
</script>

<style lang="scss">
.qx-checkbox {
  gap: 5px;
  height: fit-content;
}
.custom-checkbox {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 0.875rem;
  line-height: 1.5;
  &.disabled {
    color: $label-grey;
    .custom-label {
      color: $label-grey !important;
    }
  }

  .custom-checkbox-input {
    width: 17px;
    height: 17px;
    border-radius: 4px;
    border: 1px solid $border-grey;
    position: relative;
    cursor: pointer;
    background: $white;
    .qx-icon {
      position: absolute;
      left: -4px;
      top: -4px;
      color: $base-blue;
      font-size: 23px;
      z-index: 1;
    }
    &.checked,
    &.indeterminate {
      border-color: $base-blue;
    }
    &:focus {
      @extend %focusEffect;
    }
    &.disabled.checked {
      border: none;
      .qx-icon {
        opacity: 0.5;
      }
    }
  }
  input {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    opacity: 0;
    position: absolute;
    cursor: pointer;
    z-index: 2;
  }

  .custom-label {
    font-size: 15px;
    color: $base-grey;
    margin-left: 5px;
    cursor: pointer;
    &::after {
      background-size: 70% 70% !important;
    }
  }
  .custom-label {
    &::before,
    &::after {
      top: 0.125rem;
      width: 1rem;
      height: 1rem;
    }
  }
}
.qx-icon::before {
  cursor: pointer;
}
</style>
